import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from '../../../utils/errors';
import { UpdateUserListProps } from '../models';
import { updateUserListToPayload } from '../mappers';

const getUrl = (host: string) => {
  return `${host}/users`;
};

export const UpdateUserList = async ({ host, token, data }: UpdateUserListProps): Promise<void> => {
  try {
    const url = getUrl(host);

    const mappedData = updateUserListToPayload(data);

    const options: AxiosRequestConfig = {
      url,
      method: 'PUT',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };
    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
